import React from 'react';

import { isMobile } from 'react-device-detect';

import Auth from '@src/auth/auth';
import ResetPassword from '@src/auth/reset-password';
import NotSupport from '@src/not-support/not-support';

import FlcRoutes from '@flc/app-routes';
import FlpRoutes from '@flp/app-routes';

import { useAppSelector } from '@store/hooks';

import { IUserSession } from '@entities/user-session';

import { BusinessUnit } from './core/enums/business-unit';

import '@core/index.css';

declare global {
    interface Window {
        accessToken: string;
    }
}

const appVersion = process.env.REACT_APP_VERSION;

const App = () => {
    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    if (isMobile) return <NotSupport />;

    if (!userSession) return <Auth appVersion={appVersion} />;

    if (userSession.resetPasswordRequired) return <ResetPassword />;

    return userSession ? (
        !userSession.businessUnit || userSession.businessUnit == BusinessUnit.Cutting ? (
            <FlcRoutes userSession={userSession} appVersion={appVersion} />
        ) : (
            <FlpRoutes userSession={userSession} appVersion={appVersion} />
        )
    ) : (
        <Auth appVersion={appVersion} />
    );
};

export default App;
